import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Styles } from "./styles/sidebar.js";
import axios from "axios";
// import { Constant, imageDomain } from "../helper/Constants.js";
import { Constant, imageDomain } from "../../helper/Constants.js";

function Sidebar() {
  const [aboutText, setAboutText] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);

  // Helper to strip HTML tags
  const stripHtml = (html = "") => {
    if (typeof html !== "string") return "";
    return html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
  };

  useEffect(() => {
    // ----- Sidebar open/close logic -----
    const sidebarBtn = document.getElementById("sidebar-btn");
    const sidebarOverlay = document.getElementById("sidebar-overlay");
    const sidebarBody = document.getElementById("sidebar-body");
    const sidebarExit = document.getElementById("close-sidebar");

    const openSidebar = (e) => {
      e.preventDefault();
      if (sidebarOverlay && sidebarBody) {
        sidebarOverlay.classList.add("visible");
        sidebarBody.classList.add("opened");
      }
    };

    const closeSidebar = (e) => {
      e.preventDefault();
      if (sidebarOverlay && sidebarBody) {
        sidebarOverlay.classList.remove("visible");
        sidebarBody.classList.remove("opened");
      }
    };

    if (sidebarBtn) sidebarBtn.addEventListener("click", openSidebar);
    if (sidebarOverlay) sidebarOverlay.addEventListener("click", closeSidebar);
    if (sidebarExit) sidebarExit.addEventListener("click", closeSidebar);

    // ----- Fetch dynamic data -----
    const fetchAboutUs = async () => {
      try {
        // Only call if endpoint is configured
        if (Constant.getUrls && Constant.getUrls.getAboutUs) {
          const resp = await axios.get(Constant.getUrls.getAboutUs);
          const rawData = resp.data?.data;

          let rawDescription = "";

          if (Array.isArray(rawData) && rawData.length > 0) {
            rawDescription =
              rawData[0].description ||
              rawData[0].content ||
              rawData[0].about ||
              "";
          } else if (rawData && typeof rawData === "object") {
            rawDescription =
              rawData.description || rawData.content || rawData.about || "";
          }

          const plain = stripHtml(rawDescription).slice(0, 250);
          setAboutText(plain);
        } else {
          // Fallback text if no AboutUs URL configured
          setAboutText(
            "Welcome to AgriQuiz & VASA. We provide the best coaching and digital learning experience for agriculture aspirants and school students."
          );
        }
      } catch (err) {
        console.error("Error fetching About Us:", err);
        setAboutText(
          "Welcome to AgriQuiz & VASA. We provide the best coaching and digital learning experience for agriculture aspirants and school students."
        );
      }
    };

    const fetchBlogs = async () => {
      try {
        const url = `${Constant.getUrls.getAllBlogs}?page=1&limit=3`;
        const resp = await axios.get(url);
        const payload = resp.data?.data;

        let list = [];
        if (Array.isArray(payload?.docs)) {
          list = payload.docs;
        } else if (Array.isArray(payload)) {
          list = payload;
        } else if (payload?.data && Array.isArray(payload.data)) {
          list = payload.data;
        }

        setBlogs(list.slice(0, 3));
      } catch (err) {
        console.error("Error fetching Blogs:", err);
      }
    };

    const fetchGallery = async () => {
      try {
        const url = `${Constant.getUrls.getAllGalleryImages}?page=1&limit=6`;
        const resp = await axios.get(url);
        const payload = resp.data?.data;

        let list = [];
        if (Array.isArray(payload?.docs)) {
          list = payload.docs;
        } else if (Array.isArray(payload)) {
          list = payload;
        } else if (payload?.data && Array.isArray(payload.data)) {
          list = payload.data;
        }

        // Prefer only images if you have form_type
        const imagesOnly = list.filter(
          (g) =>
            !g.form_type ||
            g.form_type === "image" ||
            g.media_type === "image"
        );

        setGalleryImages(imagesOnly.slice(0, 6));
      } catch (err) {
        console.error("Error fetching Gallery:", err);
      }
    };

    fetchAboutUs();
    fetchBlogs();
    fetchGallery();

    // Cleanup listeners
    return () => {
      if (sidebarBtn) sidebarBtn.removeEventListener("click", openSidebar);
      if (sidebarOverlay)
        sidebarOverlay.removeEventListener("click", closeSidebar);
      if (sidebarExit) sidebarExit.removeEventListener("click", closeSidebar);
    };
  }, []); // run once

  return (
    <Styles>
      {/* Sidebar toggle button */}
      <a
        href={process.env.PUBLIC_URL + "/"}
        className="nav-link nav-sidebar"
        id="sidebar-btn"
      >
        <i className="las la-bars"></i>
      </a>

      <div className="sidebar" id="sidebar-body">
        {/* Logo + close */}
        <div className="side-logo d-flex justify-content-between">
          <div>
            <Link to={process.env.PUBLIC_URL + "/"}>
              <img
                src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                height={100}
                alt=""
              />
            </Link>
          </div>
          <div>
            <a href={process.env.PUBLIC_URL + "/"} id="close-sidebar">
              <i className="las la-times"></i>
            </a>
          </div>
        </div>

        {/* About Us (250 chars from API) */}
        <div className="side-content">
          <h5>About Us</h5>
          <p>{aboutText}</p>
        </div>

        {/* Recent Blogs (3 from blogs list API) */}
        <div className="side-post">
          <h5>Recent Blogs</h5>

          {blogs && blogs.length > 0 ? (
            blogs.map((blog) => (
              <div className="post-box d-flex" key={blog._id || blog.id}>
                <div className="post-img">
                  <img
                    src={imageDomain + (blog.blogs_poster || blog.image || "")}
                    alt={blog.blogs_title || "Blog"}
                  />
                </div>
                <div className="post-title">
                  <p>{blog.blogs_title || blog.title || "Blog Post"}</p>
                  <span>
                    {(blog.createdAt || blog.updatedAt || "")
                      ?.toString()
                      .substring(0, 10)}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <p>No blogs available.</p>
          )}
        </div>

        {/* Gallery (6 images from gallery API) */}
        <div className="side-gallery">
          <h5>Gallery</h5>
          {galleryImages && galleryImages.length > 0 ? (
            galleryImages.map((img) => (
              <img
                key={img._id || img.id}
                src={imageDomain + img.image}
                alt="gallery"
              />
            ))
          ) : (
            <>
              {/* optional: keep a small fallback or text */}
              <p>No images available.</p>
            </>
          )}
        </div>

        {/* Contact (static for now) */}
        <div className="side-contact">
          <h5>Contact Us</h5>
          <ul className="list-unstyled">
            <li>
              <i className="las la-map-marker"></i>Nagpur, Maharashtra, India
            </li>
            <li>
              <i className="las la-phone"></i>9422690015 | 9423110012
            </li>
            {/* <li>
              <i className="las la-envelope"></i>
              vasaicompdigilearn@gmail.com
            </li> */}
          </ul>
        </div>

        {/* Social (you can also map API here later if you like) */}
        <div className="side-social">
          <ul className="list-unstyled list-inline">
            <li className="list-inline-item">
              <a href={process.env.PUBLIC_URL + "/"}>
                <i className="fab fa-facebook-f"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href={process.env.PUBLIC_URL + "/"}>
                <i className="fab fa-twitter"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href={process.env.PUBLIC_URL + "/"}>
                <i className="fab fa-google"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href={process.env.PUBLIC_URL + "/"}>
                <i className="fab fa-linkedin-in"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href={process.env.PUBLIC_URL + "/"}>
                <i className="fab fa-instagram"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="sidebar-overlay" id="sidebar-overlay"></div>
    </Styles>
  );
}

export default Sidebar;
